import { UnleashAdapter } from "./unleash-adapter";
import { loadStoredOrFetchConfiguration } from "@newsenec/configuration-provider";
import { buildErrorObj } from "@newsenec/logging";
import { ErrorSerial, mfShorty } from "../constants";

let featureToggleProvider: UnleashAdapter | undefined;

export const start = async (): Promise<void> => {
    console.debug("Starting Unleash adapter");
    const environment = await getEnvironment().catch(() => "");
    featureToggleProvider = new UnleashAdapter(environment);
    await featureToggleProvider.start();
};

const getEnvironment = async (): Promise<string> => {
    const config = await loadStoredOrFetchConfiguration();
    return config.environment;
};

/**
 * WARNING: Should ONLY be used in react bootstrap cycle, consider using {@link isFeatureActive} instead.
 *
 * Returns whether feature is enabled.
 *
 * @return always resolves. Returns false in case of errors.
 */
export const isFeatureActiveAsync = async (feature: string): Promise<boolean> => {
    if (!featureToggleProvider) await start();
    const enabled = featureToggleProvider!.isFeatureEnabled(feature);
    console.debug(`Feature '${feature}': ${enabled ? "enabled" : "disabled"}`);
    return enabled;
};

/**
 * WARNING: Should NOT be used in react bootstrap cycle, consider using {@link isFeatureActiveAsync} instead if necessary.
 *
 * Returns whether feature is enabled.
 *
 * @return Returns a boolean whether the feature flag is active or not, throws an error if the provider is not yet initialised.
 */
export const isFeatureActive = (feature: string): boolean => {
    if (!featureToggleProvider)
        throw buildErrorObj(mfShorty, undefined, ErrorSerial.UnleashNotInitialized, "Unleash adapter not initialized");
    const active = featureToggleProvider.isFeatureEnabled(feature);
    console.debug(`Feature '${feature}': ${active ? "active" : "inactive"}`);
    return active;
};
